export default __webpack_public_path__ + "static/media/team.0e93afb0.png";